/**
 * Collapsible tables
 * TODO: REFACTOR THIS OR REMOVE IF UNUSED
 */
function tableCollapsible() {
	const $tableContainer = $('.table-container');
	$tableContainer.each(function () {
		if ($(this).find('.collapsible-row-parent').length) {
			$(this).addClass('collapsible');
		}
		$(this).find('.collapsible-row-child td').wrapInner('<div class="row-content" />');
	});

	$tableContainer.find('.collapsible-row-parent').click(function () {
		var opened = $(this).hasClass('active-parent');
		var level = 1;
		if ($(this).hasClass('parent-level-2')) level = 2;
		if ($(this).hasClass('parent-level-3')) level = 3;
		if ($(this).hasClass('parent-level-4')) level = 4;
		$(this).toggleClass('active-parent');
		$(this).nextUntil('.collapsible-row-parent.parent-level-' + level).each(function () {
			if (opened) {
				var conditionChilds,
					conditionParents;
				if (level === 1) {
					conditionChilds = $(this).hasClass('child-level-1') ||
						$(this).hasClass('child-level-2') ||
						$(this).hasClass('child-level-3') ||
						$(this).hasClass('child-level-4');
					conditionParents = $(this).hasClass('parent-level-1') ||
						$(this).hasClass('parent-level-2') ||
						$(this).hasClass('parent-level-3') ||
						$(this).hasClass('parent-level-4');
				}
				if (level === 2) {
					conditionChilds = $(this).hasClass('child-level-2') ||
						$(this).hasClass('child-level-3') ||
						$(this).hasClass('child-level-4');
					conditionParents = $(this).hasClass('parent-level-2') ||
						$(this).hasClass('parent-level-3') ||
						$(this).hasClass('parent-level-4');
				}
				if (level === 3) {
					conditionChilds = $(this).hasClass('child-level-3') ||
						$(this).hasClass('child-level-4');
					conditionParents = $(this).hasClass('parent-level-3') ||
						$(this).hasClass('parent-level-4');
				}
				if (level === 4) {
					conditionChilds = $(this).hasClass('child-level-4');
					conditionParents = $(this).hasClass('parent-level-4');
				}

				if (conditionChilds) {
					$(this).removeClass('active-child');
					$(this).find('.row-content').slideUp();
				}
				if (conditionParents) {
					$(this).removeClass('active-parent');
				}
			} else {
				if ($(this).hasClass('child-level-' + level)) {
					$(this).addClass('active-child');
					$(this).find('.row-content').slideDown();
				}
			}
		});
	});

	$tableContainer.each(function () {
		var $container = $(this);
		var showRows = true;
		$container.on('click', '.see-more', function () {
			var buttonThis = $(this);
			if (showRows) {
				$container.find('.collapsible-row-parent').addClass('active-parent');
				$container.find('.collapsible-row-child').addClass('active-child');
				$container.find('.collapsible-row-child').find('.row-content').slideDown();
				buttonThis.text(buttonThis.data('seeless'));
			} else {
				$container.find('.collapsible-row-parent').removeClass('active-parent');
				$container.find('.collapsible-row-child').removeClass('active-child');
				$container.find('.collapsible-row-child').find('.row-content').slideUp();
				buttonThis.text(buttonThis.data('seemore'));
			}
			showRows = !showRows;
		});
	});
}
